module.exports = __webpack_public_path__ + "img/電気回路_6_10_5.a7b1ffb6.png";